import { useState } from "react";

import { useStepContext } from "../../utils/StepContext.jsx"
import { useFormContext } from "../../utils/FormContext.jsx"
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"; 
import { useMediaQuery } from 'react-responsive';

import InfoSVG from '../../assets/InfoSVG.jsx'; 
import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import InfoModal from "../InfoModal.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";


const IlcSurvey = () => {

    const { handleNext, handleBack } = useStepContext();
    const { formData, formId, handleIlcChange, handleIlcInputChange } = useFormContext(); 
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { user } = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);

    const handleInfoClick = () => {
        setIsInfoModalOpen(true); 
    }; 

    const handleCloseInfoModal = () => {
        setIsInfoModalOpen(false); 
    }

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const InfoModalContent =
        {
        title: "Difference Between ILC and Survey",
        content: "An Improvement Location Certificate (ILC) is a certificate, not a survey. ILCs are certified by licensed surveyors and provide information about the location of structures and improvements on a property. Surveys are used to identify a property's boundary lines and are necessary for construction and permit purposes. You'll more than likely need an ILC for the purchase of a residential property."
        }; 

    const currentPageValue = 2;
    const currentSubStepProgress = 2/7; 

    const onNext = () => {
        handleNext();
    };

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750} gap={0}>
            <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
                <div className='inline-flex justify-between items-center w-full mb-5'>
                {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">ILC or Survey</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Improvement Location Certificate (ILC) or Survey</h3>}
                    <div className='gap-2 md:gap-4 items-center h-auto inline-flex'>
                        <HelpButton onClick={toggleAssist}/>
                        <SaveButton formData={formData} formId={formId}/>
                        {user && <PDFPreview formData={formData}/>}
                    </div>
                </div>
                <div className="border-blue-500 bg-blue-50 border rounded-md md:p-2 p-1 inline-flex justify-between w-full gap-2 items-start">
                    {isMobile ? <InfoSVG width={18} height={18} fill='#2563EB'/> : <InfoSVG width={23} height={23} fill='#2563EB'/>}
                    <div className="flex-col gap-2">
                        <span className="text-blue-800 text-[13px] w-full">An ILC starts around ~$1300 and up, shows above-ground improvements and utilities, while a survey starts around ~$2400 and up, provides detailed boundary information. Most often these are used to satisfy title or lender requirements.</span>
                        <br></br>
                        <span className="text-blue-800 text-[13px] w-full">Recommendation: Select "ILC" with buyer to order and pay. This strategy allows you to maintain control over the process, retaining the right to waive it later if it turns out to be unnecessary.</span>
                    </div>
                </div>
            <div className="flex flex-col mb-8">
                <div className="flex flex-row mb-2 w-full px-2 md:px-0 mt-4">
                    <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter] pr-4'>New Improvement Location Certificate or Survey?</span>
                    <InfoSVG onClick={handleInfoClick}/>
                </div>
                <div className="self-stretch w-full flex-wrap justify-start gap-[25px] inline-flex items-center pl-2 md:pl-0">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="ILC" 
                            value="ilc" 
                            checked={formData.ilcOrSurvey === 'ilc'} 
                            onChange={(e) => handleIlcChange('ilcOrSurvey', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">New ILC</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="survey"
                            value="survey" 
                            checked={formData.ilcOrSurvey === 'survey'} 
                            onChange={(e) => handleIlcChange('ilcOrSurvey', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Survey</label>
                    </div>
                </div>
            </div>


            <div className="flex flex-col justify-between mb-2 w-full px-2 md:px-0">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter] mb-2'>Who will pay for ILC or Survey?</span>
                {/* <span className="w-full h-auto text-shi-purple mb-5 text-[13px] md:text-xs font-['Inter']">Typically covered by Buyer to satisfy Title Insurance Coverage. Costs will vary</span> */}
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center flex-wrap mb-8">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="ilcPayBuyer" 
                            value="buyer" 
                            checked={formData.ilcPayment === 'buyer'} 
                            onChange={(e) => handleIlcChange('ilcPayment', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="ilcPaySeller"
                            value="seller" 
                            checked={formData.ilcPayment === 'seller'} 
                            onChange={(e) => handleIlcChange('ilcPayment', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                </div>
                <div>
                    <div className="gap-2 flex flex-col mb-8">
                        <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter]'>Additional info on ILC</span>
                        <span className='text-[13px] md:text-xs text-slate-500'>Default response</span>
                        <input 
                            type="text"
                            name="ilcPaymentText"
                            className="w-[330px] md:w-[650px] py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex"
                            placeholder=""
                            value={formData.ilcPaymentText}
                            onChange={handleIlcInputChange}
                        />
                    </div>
                </div>
            </div>    

            <div className="flex flex-col justify-between mb-2 w-full px-2 md:px-0">
                <span className='text-[14px] md:text-[16px] text-slate-600 font-[Inter] mb-2'>Who will order the ILC or Survey?</span>
                {/* <span className="w-full h-auto text-shi-purple mb-5 text-[13px] md:text-xs font-['Inter']">Typically it will be the buyers responsibility to order an ILC or Survey.</span> */}
                <div className="self-stretch justify-start gap-[25px] inline-flex items-center">
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio"
                            id="ilcOrderBuyer" 
                            value="buyer" 
                            checked={formData.ilcOrder === 'buyer'} 
                            onChange={(e) => handleIlcChange('ilcOrder', e.target.value)}
                            
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Buyer</label>
                    </div>
                    <div className="items-center gap-2 flex">
                        <input 
                            type="radio" 
                            id="ilcOrderSeller"
                            value="seller" 
                            checked={formData.ilcOrder === 'seller'} 
                            onChange={(e) => handleIlcChange('ilcOrder', e.target.value)}
                        />
                        <label className="text-black text-opacity-60 font-semibold font-['Inter']">Seller</label>
                    </div>
                </div>
            </div>        
            </div> 
            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}

        <InfoModal isOpen={isInfoModalOpen} onClose={handleCloseInfoModal}>
                <div>
                    <h1 className="text-shi-green text-2xl font-bold mb-4">{InfoModalContent.title}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.content}</p>
                </div>
        </InfoModal>
        </div>
        
    )
}

export default IlcSurvey; 